import { Input, Table } from 'antd';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import {
    blue04,
    blueDark02,
    blueLink,
    grayDark03,
    grayDark05,
    grayDark06,
} from '../../../styles/colors';
import { ClickableRow } from '../../../styles/common.styles';

export const NavigationLabel = styled('div')`
    display: flex;
    gap: 1px;
`;

// Standard hyperlink spec: link colour, underline on hover.
export const GuidelineLink = styled(NavLink)`
    color: ${blueLink};
    cursor: pointer;
    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
`;

export const LiveGuidelinesListContainer = styled('div')`
    padding: 24px;
`;

export const LiveGuidelinesListHeader = styled('div')`
    display: flex;
    justify-content: flex-start;
    margin-bottom: 40px;
`;

export const LiveGuidelinesListControls = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 4px 0 16px;

    > div:first-child {
        display: flex;
        align-items: center;
        gap: 16px;
    }
`;

export const SearchInput = styled(Input)`
    min-width: 220px;
    border-radius: 2px;
    font-family: 'Proxima Nova';
    font-size: 13px;
    padding: 8px;
`;

export const TableCount = styled('span')`
    color: ${blueDark02};
    font-family: 'Proxima N W15 Bold';
    font-size: 14px;
    white-space: nowrap;
`;

export const UnselectAllButton = styled(ClickableRow)`
    color: ${blueLink};
    white-space: nowrap;
    font-size: 13px;
    font-family: 'Proxima Nova';
    margin-left: 6px;
`;

export const GuideLineTable = styled(Table)`
    .ant-table-thead > tr > th {
        background: transparent !important;
        color: ${blueDark02} !important;
        font-family: 'Proxima N W15 Bold';
        font-size: 10px;
        font-weight: normal;
        text-transform: uppercase;
        border-bottom: 1px solid ${grayDark06} !important;
        padding: 6px;
    }

    .ant-table-thead > tr > th::before {
        display: none !important;
    }

    .ant-table-column-sorters {
        display: inline-flex !important;
        justify-content: flex-start !important;
        align-items: center;
        width: auto !important;
    }

    .ant-table-column-sort-title {
        flex: none !important;
    }

    .ant-table-column-sorter {
        margin-left: 5px !important;
        width: 12px !important;
        height: 12px !important;
        flex: 0 0 12px !important;
        position: relative;
    }

    .ant-table-column-sorter-inner {
        display: none !important;
    }

    .ant-table-column-sorter::after {
        content: '';
        position: absolute;
        inset: 0;
        width: 7px;
        height: 7px;
        background: url('src/assets/images/caret-down.svg') center / contain no-repeat;
        transform: rotate(0deg);
        transition: transform 0.15s ease;
    }

    .ant-table-column-sorter:has(.ant-table-column-sorter-up.active)::after {
        transform: rotate(180deg);
    }

    .ant-table-column-sorter:has(.ant-table-column-sorter-down.active)::after {
        transform: rotate(0deg);
    }

    .ant-table-thead > tr > th.ant-table-selection-column,
    .ant-table-tbody > tr > td.ant-table-selection-column {
        padding-left: 0 !important;
        padding-right: 0 !important;
        text-align: left !important;
    }

    .ant-table-thead > tr > th.ant-table-selection-column + th,
    .ant-table-tbody > tr > td.ant-table-selection-column + td {
        padding-left: 8px;
    }

    .ant-table-tbody > tr > td {
        padding: 8px 0px;
        padding-left: 6px;
        border-bottom: none;
        color: ${grayDark03};
        font-size: 14px;
        font-family: 'Proxima Nova';
        font-weight: 400;
    }

    .ant-table-tbody > tr:hover > td {
        background: transparent !important;
    }
    .ant-table-tbody > tr > td {
        background: transparent;
    }

    .ant-table-thead > tr > th:last-child,
    .ant-table-tbody > tr > td:last-child {
        padding-right: 0;
    }
`;

export const DotsAction = styled('div')`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${grayDark05};
    box-shadow: 0px 8px 0px ${grayDark05}, 0px 16px 0px ${grayDark05};
    position: absolute;
    top: 13px;
`;

export const OpenMenuButton = styled('button')`
    border: none;
    position: relative;
    background-color: transparent;
    cursor: pointer;
    padding: 20px;

    div {
        top: 33%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    &:hover {
        background-color: ${blue04};
    }
`;

export const ProductActionMenuItem = styled('span')`
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${grayDark03};
    white-space: nowrap;
`;
